import { request } from '@/apis/request';

const VERSION = '/v1.0.0'
const PRE_PATH = '/cBondIssuance/center';
// 获取主承销商信息
export function getMemInfo(data) {
  return request({
    url: `${PRE_PATH}/MemInfoQuery${VERSION}`,
    method: 'post',
    data
  });
}

// 获取主承销商信息头部文字信息
export function getIndexMemInfoCollect(data) {
  return request({
    url: `${PRE_PATH}/indexMemInfoCollect${VERSION}`,
    method: 'post',
    data
  });
}

// 概况-主承销商特征信息（银行概况）
export function getMemIndexInfo(data) {
  return request({
    url: `${PRE_PATH}/MemIndexInfo${VERSION}`,
    method: 'post',
    data
  });
}

// 概况-主承销商雷达图
export function getMemRadarInfo(data) {
  return request({
    url: `${PRE_PATH}/MemRadarInfo${VERSION}`,
    method: 'post',
    data
  });
}

// 概况-主承销商信息（承销特色，简介，联系方式）
export function getMemInfoQuery(data) {
  return request({
    url: `${PRE_PATH}/MemInfoQuery${VERSION}`,
    method: 'post',
    data
  });
}

// 概况-主承销商信息修改（承销特色，简介，联系方式）
export function getMemInfoDetailUpdate(data) {
  return request({
    url: `${PRE_PATH}/MemInfoDetailUpdate${VERSION}`,
    method: 'post',
    data
  });
}

// 获取所有菜单信息
export function getMenuInfo(data) {
  return request({
    url: `${PRE_PATH}/SysMenuTreeQuery${VERSION}`,
    method: 'post',
    data
  });
}

// 信息集锦-查询信息接口
export function getKnowledgeCollectionInfoQuery(data) {
  return request({
    url: `${PRE_PATH}/KnowledgeCollectionInfoQuery${VERSION}`,
    method: 'post',
    data
  });
}

// 信息集锦-问题反馈
export function getKnowledgeCollectionInfoInsert(data) {
  return request({
    url: `${PRE_PATH}/KnowledgeCollectionInfoInsert${VERSION}`,
    method: 'post',
    data
  });
}


// 债权工具查询
export function getMemBondDetailInfo(data) {
  return request({
    url: `${PRE_PATH}/MemBondDetailInfo${VERSION}`,
    method: 'post',
    data
  });
}

// 获取一级市场动态信息
export function getMemBondInfo(data) {
  return request({
    url: `${PRE_PATH}/MemBondDetailInfo${VERSION}`,
    method: 'post',
    data
  });
}

// 获取中国债券市场总体情况
export function getBondQuery(data) {
  return request({
    url: `${PRE_PATH}/query`,
    method: 'post',
    data
  });
}

// 获取中国债券市场总体情况
export function getBondYear(data) {
  return request({
    url: `${PRE_PATH}/queryYear`,
    method: 'post',
    data
  });
}

// 获取业务统计表格
export function getUnderwriteBusinessStatisticsListInfo(data) {
  return request({
    url: `${PRE_PATH}/getUnderwriteBusinessStatisticsList${VERSION}`,
    method: 'post',
    data
  });
}

// 获取评论权限
export function getCheckIssuser(data) {
  return request({
    url: `${PRE_PATH}/checkIssuser${VERSION}`,
    method: 'post',
    data
  });
}

// 获取首页业务统计年份
export function getUnderwriteBusinessStatisticsYearListInfo(data) {
  return request({
    url: `${PRE_PATH}/getUnderwriteBusinessStatisticsYearList${VERSION}`,
    method: 'post',
    data
  });
}

// 获取首页业务统计年份
export function getReviewDataList(data) {
  return request({
    url: `${PRE_PATH}/reviewDataList${VERSION}`,
    method: 'post',
    data
  });
}

// 获取评论列表
export function getMemContentList(data) {
  return request({
    url: `${PRE_PATH}/getMemContentList${VERSION}`,
    method: 'post',
    data
  });
}

// 获取数据年份
export function getBondMarketSituationYearList(data) {
  return request({
    url: `${PRE_PATH}/getBondMarketSituationYearList${VERSION}`,
    method: 'post',
    data
  });
}

// 获取我的主页
export function getBondMarketSituationYearListtest(data) {
  return request({
    url: `${PRE_PATH}/getBondMarketSituationYearList${VERSION}`,
    method: 'post',
    data
  });
}

// 查询我的主页日志列表
export function getLogInfoList(data) {
  return request({
    url: `${PRE_PATH}/LogInfoList${VERSION}`,
    method: 'post',
    data
  });
}
